export default "/images/vendor/flag-icon-css/flags/4x3/pg.svg?dcb8c4ab032af81620bdf25bc2ff9575";